<template>
  <div ref="chartRef" class="line-chart-container"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "LineChart",
  props: {
    data: {
      type: Array,
      default: () => [1, 1, 1, 1, 1, 1, 1],
    },
    labels: {
      type: Array,
      default: () => [
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
      ],
    },
    activeIndex: {
      type: Number,
      default: -1, // -1 表示取消 hover 效果
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  watch: {
    data: {
      handler() {
        this.updateChart();
      },
      deep: true,
    },
    labels: {
      handler() {
        this.updateChart();
      },
      deep: true,
    },
    activeIndex() {
      this.setActiveHover();
    },
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartRef);
      this.updateChart();
    },

    updateChart() {
      if (!this.chart) return;

      const option = {
        /* tooltip: {
          trigger: 'axis',
          triggerOn: 'mousemove|click', // 正常鼠标移入仍可触发
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: function(params) {
            return params[0].name + '<br/>' + params[0].seriesName + ': ' + params[0].value
          }
        }, */
        tooltip: {
          triggerOn: "none",
        },
        grid: {
          left: "3%",
          right: "8%",
          bottom: "3%",
          top: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.labels,
            axisLabel: {
              fontSize: 12,
              color: "#999",
            },
            axisLine: {
              lineStyle: {
                color: "#f0f0f0",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              fontSize: 12,
              color: "#999",
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: "#f0f0f0",
              },
            },
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(24, 144, 255, 0.3)",
                  },
                  {
                    offset: 1,
                    color: "rgba(24, 144, 255, 0.05)",
                  },
                ],
              },
            },
            emphasis: {
              focus: "series",
            },
            lineStyle: {
              color: "#1890ff",
              width: 2,
            },
            symbol: "circle",
            symbolSize: 6,
            itemStyle: {
              color: "#1890ff",
              borderColor: "#fff",
              borderWidth: 2,
            },
            data: this.data,
          },
        ],
      };

      this.chart.setOption(option);
      this.setActiveHover();
    },

    setActiveHover() {
      if (!this.chart) return;

      // 先清掉之前的高亮和 tooltip
      this.chart.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
      });

      this.chart.dispatchAction({
        type: "hideTip",
      });

      // activeIndex 无效时，直接取消 hover 效果
      if (
        this.activeIndex === -1 ||
        this.activeIndex === null ||
        this.activeIndex === undefined ||
        this.activeIndex < 0 ||
        this.activeIndex >= this.data.length
      ) {
        return;
      }

      // 高亮当前点
      this.chart.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: this.activeIndex,
      });

      // 显示 tooltip，模拟 hover
      this.chart.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        dataIndex: this.activeIndex,
      });
    },

    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },
};
</script>

<style scoped>
.line-chart-container {
  width: 100%;
  height: 150px;
}
</style>
